import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../../../reducers';
import { getInitialState } from '../../../app/appSlice';

const UpgradeStatus = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { upgradeStatus: status } = useSelector(
    (state: RootState) => state.plan.subscription
  );

  // Clear payment status and redirect after 3 seconds after payment done
  useEffect(() => {
    if (['succeeded', 'failed'].includes(status)) {
      setTimeout(async () => {
        await dispatch(getInitialState());

        navigate({
          pathname: '/dashboard',
        });
      }, 3000);
    }
  }, [status]);

  switch (status) {
    case 'pending':
      return <div>Payment in progress</div>;
    case 'succeeded':
      return <div>Succeesfully upgraded</div>;
    case 'failed':
      return <div>Failed to upgrade. Please try again later.</div>;
    case 'idle':
    default:
      return <div>No payment in progress</div>;
  }
};

export default UpgradeStatus;
